import React from 'react';
import { Switch, Route } from 'react-router-dom';
import List from './List';

const SalesReports = props => {
  return (
    <Switch>
      <Route path="/" component={List} />
    </Switch>
  );
};

export default SalesReports;